import { getDeviceConfig } from '@/device/deviceConfig'

export function initializeDeviceStyling() {
    const classList = document.documentElement.classList
    classList.add(getDeviceConfig().deviceType)
}
